import { ErrorTypes } from './ErrorEnums.ts';
import { ErrorAuth, ErrorBlocking, ErrorDefault, ErrorMustBeMember, ErrorMustLogin } from './Errors.ts';
export class ErrorController {
    static deserializeErrorData(errorData) {
        switch(errorData.type){
            case ErrorTypes.DefaultError:
                return ErrorDefault.deserialize(errorData);
            case ErrorTypes.AuthError:
                return ErrorAuth.deserialize(errorData);
            case ErrorTypes.MustLogin:
                return ErrorMustLogin.deserialize(errorData);
            case ErrorTypes.MustBeMember:
                return ErrorMustBeMember.deserialize(errorData);
            case ErrorTypes.Blocking:
                return ErrorBlocking.deserialize(errorData);
            default:
                return undefined;
        }
    }
}
